import { ErrorMessageWrapper } from "@/common/components/ErrorMessageWrapper";
import { ShowHeader } from "@/common/components/ShowHeader";
import Tabs from "@/common/components/Tabs";
import { tabsDefaultWithFlexGrowClassName } from "@/common/constants/tabsDefaultClassName.constant";
import { useEffect, useMemo } from "react";
import { useParams } from "react-router-dom";
import { maintenanceWorkflowActions } from "../../constants/maintenanceWorkflowActions.constant";
import { useMaintenanceWorkflow } from "../../hooks/useMaintenanceWorkflow";
import { useWorkflowShowStore } from "../../stores/workflowShowStore";
import { getWorkflowTabsList } from "../../utils/getWorkflowTabsList";
import MaintenanceWorkflowSidebar from "./components/MaintenanceWorkflowSidebar";
import MaintenanceWorkflowForwardingShowLoading from "./components/tabs/forwardingsTab/MaintenanceWorkflowForwardingShowLoading";

const MaintenanceWorkflowsShow = () => {
  const { id } = useParams();

  const {
    init,
    setEquipment,
    setCurrentEquipmentUsage,
  } = useWorkflowShowStore();

  const {
    data: workflow,
    isPending: workflowIsPending,
    error: workflowError = {} as any,
    refetch: refetchWorkflow,
    dataUpdatedAt: workflowUpdatedAt,
  } = useMaintenanceWorkflow(id);

  const ActionsComponent = useMemo(() => {
    if (!workflow?.current_forwarding?.status) {
      return null;
    }

    const action = maintenanceWorkflowActions[workflow?.current_forwarding?.status];

    return action?.component || null;
  }, [workflow?.current_forwarding?.status]);

  useEffect(() => {
    init();
  }, []);

  useEffect(() => {
    if (workflow?.equipment) {
      setEquipment(workflow.equipment);
    }

    if (workflow?.equipment_usage_declaration) {
      setCurrentEquipmentUsage(workflow.equipment_usage_declaration.value);
    }
  }, [workflowUpdatedAt]);

  return (
    <div className="inner-screen">
      <ShowHeader
        goBack
        goBackProps={{ fallback: `/maintenance-workflows`, searchLastRouteFromFallback: true }}
        isLoading={workflowIsPending}
        title="Processos de manutenção"
        subtitle={workflow?.id.split('-')[0].toUpperCase()}
        titleClassName="text-md"
        className="text-white-400"
        subtitleClassName="text-nowrap font-medium"
        buttons={ActionsComponent && <ActionsComponent />}
      />

      <ErrorMessageWrapper
        statusCode={workflowError?.status}
        refetchFunction={refetchWorkflow}
        className="flex-1"
      >
        <div className="flex-1 flex overflow-auto gap-4">
          <MaintenanceWorkflowSidebar workflow={workflow} />

          <div className="flex-1 flex flex-col">
            {workflowIsPending && <MaintenanceWorkflowForwardingShowLoading />}

            {!workflowIsPending && (
              <Tabs
                {...tabsDefaultWithFlexGrowClassName}
                tabsList={getWorkflowTabsList(
                  workflow,
                )}
              />
            )}
          </div>
        </div>
      </ErrorMessageWrapper>
    </div>
  );
}

export default MaintenanceWorkflowsShow;
